<template>
  <div>
    <b-table
        striped
        hover
        :selectable=true
        select-mode=single
        :items="items"
        :fields="tableFields"
        @row-selected="onRowSelected">
    </b-table>
  </div>
</template>

<script> 
import replacementRules from '@/store/realtime/replacementRules'

export default {
    name: 'ReplacementRuleConfigTable',
    data: function() {
        return {
            tableFields: [
                { key: "type" , label: this.$t('replacementRules.textReplacementConfiguration') },
               
            ]
        }
    },
    beforeCreate() {
        if( !this.$store.state.replacementRules ) {
            this.$store.registerModule("replacementRules" , replacementRules )
        }
    },
    mounted() {
        this.$store.dispatch('replacementRules/getReplacementRuleConfigs')
    },
    computed: {
        items() {
            return this.$store.getters['replacementRules/getReplacementRuleConfigs']
        }
    },
    methods:{
        onRowSelected( items ) {
            if( items == undefined ) return
            if( items.length == 0 ) {
                //this.$emit("selectItem" , null )
                return
            }
            this.$emit('selectItem' , items[0] )
        }
    }
}
</script>

<style>

</style>